import { Email } from "types";
import { validateParams } from "../hookHelpers";
import { ResourceFetchOptions, useResource } from "../useResource";

export const useEmail = (emailId: string | undefined, params: any = {}, options: ResourceFetchOptions<Email> = {}) => {
    params = validateParams({ context: "all", ...params });

    const response = useResource<Email>(["emails", emailId], params, options);
    return { ...response, email: response.data, isLoadingEmail: response.isLoading };
};
